/* Kuyruğu drain eden merkezi senkron modülü.
 * - flushQueue(): tüm bekleyen kayıtları sırayla dener; başarılıyı siler, başarısızı bırakır.
 * - Otomatik tetikleyiciler: window "online" olayı + ilk yüklemede + 60sn'de bir sağlama.
 */

import axios from "axios";
import { API } from "@/context/AuthContext";
import { getAllPending, removePending, updatePending, notifyCount } from "@/lib/offlineQueue";

let flushing = false;
let unsub = null;

const uploadPhotoIfAny = async (rec) => {
  if (!rec.photoBlob) return null;
  const fd = new FormData();
  const file = new File(
    [rec.photoBlob],
    rec.photoName || "irsaliye.jpg",
    { type: rec.photoType || "image/jpeg" }
  );
  fd.append("file", file);
  const { data } = await axios.post(`${API}/upload`, fd, {
    headers: { "Content-Type": "multipart/form-data" },
    timeout: 30000,
  });
  return data?.path || null;
};

const sendOne = async (rec) => {
  const payload = { ...(rec.payload || {}) };
  // photo_path yoksa ve blob varsa önce yükle
  if (!payload.photo_path && rec.photoBlob) {
    try {
      const path = await uploadPhotoIfAny(rec);
      if (path) payload.photo_path = path;
    } catch (e) {
      // görsel yüklenemezse yine de veriyi göndermeyi dene (foto null olur)
    }
  }
  if (rec.kind === "bulk") {
    await axios.post(`${API}/materials/bulk`, payload, { timeout: 30000 });
  } else {
    await axios.post(`${API}/materials`, payload, { timeout: 30000 });
  }
};

export const flushQueue = async ({ onProgress } = {}) => {
  if (flushing) return { skipped: true };
  if (typeof navigator !== "undefined" && navigator.onLine === false) {
    return { offline: true };
  }
  flushing = true;
  let sent = 0;
  let failed = 0;
  try {
    const all = await getAllPending();
    for (const rec of all) {
      try {
        await sendOne(rec);
        await removePending(rec.id);
        sent += 1;
        onProgress?.({ sent, failed, remaining: all.length - sent - failed });
      } catch (err) {
        const status = err?.response?.status;
        // 4xx istemci hatası → tekrar denemek anlamsız, kayıttan çıkar
        if (status && status >= 400 && status < 500) {
          await removePending(rec.id);
          failed += 1;
        } else {
          await updatePending(rec.id, {
            tries: (rec.tries || 0) + 1,
            lastError: err?.message || "network error",
          });
        }
      }
    }
    await notifyCount();
    return { sent, failed };
  } finally {
    flushing = false;
  }
};

export const startAutoSync = () => {
  if (unsub) return; // tek sefer
  const handler = () => flushQueue();
  window.addEventListener("online", handler);
  const iv = setInterval(() => {
    if (navigator.onLine) flushQueue();
  }, 60000);
  // ilk yüklemede de dene
  setTimeout(handler, 1500);
  unsub = () => {
    window.removeEventListener("online", handler);
    clearInterval(iv);
  };
};
